// extracted by mini-css-extract-plugin
export default {"wrapper":"y0-z","play":"z0-z"};